import { AiTool } from '../toolRegistry'

// Navigation tool. `base` is the current space/environment path prefix
// (e.g. /spaces/x/environments/master), `push` is vue-router's push.
export function navigateToolset(base: string, push: (path: string) => any): AiTool[] {
	const destinations: { [k: string]: string } = {
		entries: '/entries',
		content_types: '/content_types',
		assets: '/assets',
		media: '/assets',
		graphs: '/graphs',
		settings: '/settings',
	}

	return [ {
		name: 'navigate',
		definition: {
			name: 'navigate',
			description:
				'Navigate the editor to another view within the current space/environment. ' +
				'Use "entry" together with entry_id to open a specific entry.',
			input_schema: {
				type: 'object',
				properties: {
					destination: {
						type: 'string',
						enum: [ ...Object.keys(destinations), 'entry' ],
						description: 'Where to navigate.',
					},
					entry_id: {
						type: 'string',
						description: 'Entry id, required when destination is "entry".',
					},
				},
				required: [ 'destination' ],
			},
		},
		handler: (input: any) => {
			const { destination, entry_id } = input ?? {}
			let path: string
			if (destination === 'entry') {
				if (!entry_id) throw new Error('entry_id is required when destination is "entry"')
				path = base + '/entries/' + entry_id
			}
			else {
				const suffix = destinations[destination]
				if (!suffix) throw new Error('Unknown destination: ' + destination)
				path = base + suffix
			}
			push(path)
			return 'Navigated to ' + path
		},
	} ]
}
